// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "../src/redux/configureStore"; // Adjust path if needed
// import TwoTabsPage from "./pages/TwoTabsPage";
// import Dashboard from "./pages/Dashboard";
// import CompaniesDashboard from "./pages/CompaniesDashboard";
// import ResumeScreeingCandidates from "./pages/ResumeScreening/ResumeScreeingCandidates";
// import ResumeScreeningCandidateOverallResult from "./pages/ResumeScreening/ResumeScreeningCandidateOverallResult";
// import ResumeScreeningCandidateFullReport from "./pages/ResumeScreening/ResumeScreeningCandidateFullReport";
// import MyAssessments from "../src/pages/Assessments/Assessments";
// import AssessmentsCreateOrEdit from "../src/pages/Assessments/AssessmentsCreateOrEdit";
// import InterviewResultsCandidates from "../src/pages/InterviewResults/InterviewResultsCandidates";
// import InterviewResultsCandidateOverallResult from "../src/pages/InterviewResults/InterviewResultsCandidateOverallResult";
// import InterviewResultsCandiateFullReport from "../src/pages/InterviewResults/InterviewResultsCandiateFullReport";
// import GetgeekLogin from "./components/GetgeekLogin";
// import OTPVerification from "./components/OTPVerification";
// import { useSessionTimeout } from "../src/hooks/useSessionTimeout";
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<GetgeekLogin />} />
//         <Route path="OTPVerification" element={<OTPVerification />} />

//         <Route path="/Dashboard" element={<Dashboard />} />
//         <Route path="/CompaniesDashboard" element={<CompaniesDashboard />} />
//         <Route path="/TwoTabsPage" element={<TwoTabsPage />} />
//         <Route
//           path="resume-screening-candidates/:postId"
//           element={<ResumeScreeingCandidates />}
//         />
//         <Route
//           path="resume-screening-candidates/:postId/candidate-result/:resumeId"
//           element={<ResumeScreeningCandidateOverallResult />}
//         />
//         <Route
//           path="resume-screening-candidates/:postId/candidate-result/:resumeId/full-report"
//           element={<ResumeScreeningCandidateFullReport />}
//         />

//         <Route path="create" element={<AssessmentsCreateOrEdit />} />
//         <Route path="my-assessments" element={<MyAssessments />} />

//         <Route
//           path="interview-candidates/:id/:id_type"
//           element={<InterviewResultsCandidates />}
//         />
//         <Route
//           path="interview-candidates/:postId/candidate-result/:resumeId"
//           element={<InterviewResultsCandidateOverallResult />}
//         />
//         <Route
//           path="interview-candidates/:postId/candidate-result/:resumeId/full-report"
//           element={<InterviewResultsCandiateFullReport />}
//         />
//       </Routes>
//     </BrowserRouter>
//   </Provider>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App"; // App component import karo
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/configureStore";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
